/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(['../constants', './LineAndAreaBaseConfig'], function(constants, BaseConfig) {
	'use strict';

	class Rave2bundlearea extends BaseConfig {
		constructor() {
			super();
		}

		get config(){
			const config = super.config;
			config['type'] = 'Area';
			config.slots.series['useInTopBottomQueries'] = false;
			config.slots.series['stackValuesOnAxis'] = true;
			config.slots.categories['selectable'] = false;
			config['shouldMultiPointSelectionSummarize'] = true;

			config.properties['lineWithPoints.symbol'] = { 'active': false };
			config.properties['markers.visible'] =  {
				'active': false,
				'defaultValue': false,
				'isReadOnly': true
			};

			return config;
		}
	}
	return Rave2bundlearea;
});
